import React, { useState } from "react";
import { TableBody, TableRow, TableCell, Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";

import HubTableSubRow from "./HubTableSubRow";
import { HubIcon } from "../HubIcon";
import {
  getNestedValue,
  handleClick,
  handleEvent,
  processValue,
} from "./helper";

const HubTableBody = ({
  items = [],
  groups = [],
  keys = [],
  condition = () => {},
  ContextMenu,
  ContextMenuProps,
  RenderElement,
  RenderElementProps = {},
  includeCheckbox,
  includeChevron,
  onRowClick,
  includeEnd,
  spacerProps = {},
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleNav = (e, route, id) => {
    handleEvent(e);
    navigate(`/${route}/${id}`);
  };

  const getCellProps = (key, item) => {
    let props = {};
    if (key?.sx) props.sx = key.sx;
    if (key?.variant) props.variant = key.variant;
    if (key?.isCheckbox) props.padding = "checkbox";
    if (key?.onClick) {
      const onClick = (e) => handleClick(e, key, item);
      props.onClick = onClick;
      props.onMouseDown = onClick;
    }
    if (key?.navigate) {
      const onNav = (e) =>
        handleNav(e, key.route, getNestedValue(item, key?.routeId || key.id));
      props.onClick = onNav;
      props.onMouseDown = onNav;
    }
    return props;
  };

  const handleRowClick = (e, item, idx) => {
    onRowClick && onRowClick(e, item);
    RenderElement && setOpen(open === idx ? null : idx);
  };

  const length =
    keys.length +
    (includeCheckbox ? 1 : 0) +
    (includeChevron ? 1 : 0) +
    (ContextMenu || includeEnd ? 1 : 0);

  const TemplateTableRow = ({ item, index }) => (
    <>
      <TableRow
        key={index}
        {...condition(item)}
        onClick={(e) => handleRowClick(e, item, index)}
      >
        {includeCheckbox && (
          <TableCell variant="small">
            <Checkbox sx={{ padding: 0 }} />
          </TableCell>
        )}
        {includeChevron && (
          <TableCell variant="small">
            <HubIcon
              icon={open === index ? "ChevronDown" : "ChevronRight"}
              size="12px"
            />
          </TableCell>
        )}
        {keys.map((key) => (
          <TableCell {...getCellProps(key, item)}>
            {processValue(item, key)}
          </TableCell>
        ))}
        {ContextMenu && (
          <TableCell variant="small">
            <ContextMenu item={item} index={index} {...ContextMenuProps} />
          </TableCell>
        )}
      </TableRow>
      {RenderElement && (
        <HubTableSubRow
          isOpen={open === index && open !== null}
          item={item}
          length={length}
          RenderElement={RenderElement}
          RenderElementProps={RenderElementProps}
        />
      )}
    </>
  );

  const groupLength = groups?.length;

  return (
    <TableBody>
      {!groupLength &&
        items?.map((item, index) => (
          <TemplateTableRow item={item} index={index} />
        ))}
      {!items?.length &&
        groups
          ?.map((group, idx) => [
            ...group.items?.map((item, index) => (
              <TemplateTableRow item={item} index={idx + index} />
            )),
            ...(idx !== groupLength - 1
              ? [
                  <TableRow {...spacerProps}>
                    <TableCell variant="small" colSpan={length}></TableCell>
                  </TableRow>,
                ]
              : []),
          ])
          .flat()}
    </TableBody>
  );
};

export default HubTableBody;
